import * as React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { default as UsuarioListado } from "../../components/Usuario";
import {
  sagaGetUsuarios,
  sagaHabilitarUsuario,
  sagaConfirmarUsuario,
  sagaMailConfirmarUsuario,
  sagaEliminarUsuario,
  sagaReactivarUsuario,
  sagaReestablecerUsuario,
  sagaGetLocalidades,
} from "../../reducers/usuarioReducer/actions";
import { instalacionSelector } from "../../selectors/sessionSelector";
import * as sessionActions from "../../reducers/sessionReducer/actions";
import { usuariosSelector, localidadesSelector } from "../../selectors/usuarioSelector";
import { usuarioSelector } from "../../selectors/sessionSelector";

class UsuariosContainer extends React.Component {
  constructor(props) {
    super(props);
    // Se matienen los filtros a partir del localStorage
    const filtroTipoUsuario = localStorage.getItem("filtroTipoUsuario");
    if (filtroTipoUsuario) this.default_busqueda.filtroTipoUsuario = filtroTipoUsuario == "true";
    const filtroEstado = localStorage.getItem("filtroEstado");
    if (filtroEstado) this.default_busqueda.filtroEstado = filtroEstado == "true";
    const cantFiltros = localStorage.getItem("cantFiltros");
    if (cantFiltros) this.default_busqueda.cantFiltros = parseInt(cantFiltros);
    const listaBlancaBusqueda = localStorage.getItem("listaBlancaBusqueda");
    if (listaBlancaBusqueda) this.default_busqueda.listaBlanca = listaBlancaBusqueda == "true";
    const listaNegraBusqueda = localStorage.getItem("listaNegraBusqueda");
    if (listaNegraBusqueda) this.default_busqueda.listaNegra = listaNegraBusqueda == "true";
    const tipoUsuarioBusqueda = localStorage.getItem("tipoUsuarioBusqueda");
    if (tipoUsuarioBusqueda) this.default_busqueda.tipoUsuario = tipoUsuarioBusqueda;
    const nombreBusqueda = localStorage.getItem("nombreBusqueda");
    if (nombreBusqueda) this.default_busqueda.nombre = nombreBusqueda;
    const estadoBusqueda = localStorage.getItem("estadoBusqueda");
    if (estadoBusqueda) this.default_busqueda.estado = estadoBusqueda;
    const nombre_apellidoBusqueda = localStorage.getItem("nombre_apellidoBusqueda");
    if (nombre_apellidoBusqueda) this.default_busqueda.nombre_apellido = nombre_apellidoBusqueda;
    /*        
        const noHabilitadosBusqueda = localStorage.getItem('noHabilitadosBusqueda');
        if(noHabilitadosBusqueda)
            this.default_busqueda.noHabilitados = noHabilitadosBusqueda == "true";
        const noConfirmadosBusqueda = localStorage.getItem('noConfirmadosBusqueda');
        if(noConfirmadosBusqueda)
            this.default_busqueda.noConfirmados = noConfirmadosBusqueda == "true";
        const localidadesBusqueda = localStorage.getItem('localidadesBusqueda');
        if(localidadesBusqueda)
            this.default_busqueda.localidades = localidadesBusqueda;
        const localidadBusqueda = localStorage.getItem('localidadBusqueda');
        if(localidadBusqueda)
            this.default_busqueda.localidad = localidadBusqueda;
        const razon_socialBusqueda = localStorage.getItem('razon_socialBusqueda');
        if(razon_socialBusqueda)
            this.default_busqueda.razon_social = razon_socialBusqueda;    
        */
    this.state = {
      ...this.default_busqueda,
      localidades: [],
      localidadSuggest: false,
      localidadClose: () => {
        this.setState({ localidadSuggest: false });
      },
      localidadOpen: () => {
        this.setState({ localidadSuggest: true });
      },
      openModal: false,
      openModalConfirmar: false,
      tiposUsuario: props.tiposUsuario,
      estados: props.estados,
      openModalConfirm: false,
      botonOk: "",
      handleOk: "",
      handleOnCloseConfirmacion: () => {
        this.setState({ openModalConfirm: false });
      },
      usuarioCargado: false,
      openModalNotificaciones: false,
      notificaciones: [],
    };
    // busco los datos iniciales
    this.busqueda(1);
  }

  componentDidUpdate = () => {
    if (
      this.state.usuarioCargado === false &&
      this.props.user &&
      this.props.user.idRol !== undefined
    ) {
      this.setState({ usuarioCargado: true }, () => {
        if (this.props.user.idRol !== 1) {
          window.location.hash = "/";
        }
      });
    }
  };

  default_busqueda = {
    localidades: [],
    nombre: "",
    nombre_apellido: "",
    razon_social: "",
    tipoUsuario: 3,
    estado: 2,
    localidad: "",
    noHabilitados: false,
    noConfirmados: false,
    listaNegra: false,
    listaBlanca: false,
    cantFiltros: 0,
    filtroTipoUsuario: false,
    filtroEstado: false,
  };

  busqueda(page) {
    this.props.sagaGetUsuarios(
      this.state.nombre,
      this.state.nombre_apellido,
      this.state.razon_social,
      this.state.tipoUsuario,
      this.state.estado,
      this.state.localidad,
      this.state.noHabilitados,
      this.state.noConfirmados,
      this.state.listaBlanca,
      this.state.listaNegra,
      page,
      15
    );
  }

  handleFiltro = (e) => {
    if (["listaBlanca", "listaNegra"].find((x) => x === e.target.name)) {
      this.setState({ [e.target.name]: e.target.checked });
      if (e.target.name == "listaBlanca") {
        localStorage.setItem("listaBlancaBusqueda", e.target.checked);
        this.default_busqueda.listaBlanca = e.target.checked;
        //---CantFiltros
        if (e.target.checked) {
          this.default_busqueda.cantFiltros = this.state.cantFiltros + 1;
          this.setState({ cantFiltros: this.default_busqueda.cantFiltros });
          localStorage.setItem("cantFiltros", this.default_busqueda.cantFiltros);
        } else {
          this.default_busqueda.cantFiltros = this.state.cantFiltros - 1;
          this.setState({ cantFiltros: this.default_busqueda.cantFiltros });
          localStorage.setItem("cantFiltros", this.default_busqueda.cantFiltros);
        }
        //--------------
      } else if (e.target.name === "listaNegra") {
        localStorage.setItem("listaNegraBusqueda", e.target.checked);
        this.default_busqueda.listaNegra = e.target.checked;
        //---CantFiltros
        if (e.target.checked) {
          this.default_busqueda.cantFiltros = this.state.cantFiltros + 1;
          this.setState({ cantFiltros: this.default_busqueda.cantFiltros });
          localStorage.setItem("cantFiltros", this.default_busqueda.cantFiltros);
        } else {
          this.default_busqueda.cantFiltros = this.state.cantFiltros - 1;
          this.setState({ cantFiltros: this.default_busqueda.cantFiltros });
          localStorage.setItem("cantFiltros", this.default_busqueda.cantFiltros);
        }
        //--------------
      }
    } else {
      /*
        else if( ["noHabilitados","noConfirmados"].find(x=>x===e.target.name) )
        {
            this.setState({[e.target.name]:e.target.checked})
            if(e.target.name === "noHabilitados"){
                this.setState({noHabilitados:e.target.checked})
                localStorage.setItem('noHabilitadosBusqueda', e.target.checked)
                this.default_busqueda.noHabilitados = e.target.checked;
            }
            else if(e.target.name === "noConfirmados") {
                if(e.target.checked == true) {
                    localStorage.setItem('noConfirmadosBusqueda', true)
                    this.default_busqueda.noConfirmados = true;
                }
                else {
                    localStorage.setItem('noConfirmadosBusqueda', false)
                    this.default_busqueda.noConfirmados = false;
                }
            }
        }
        else if(["localidad"].find(x=>x===e.target.name))
        {
            this.setState({[e.target.name]:e.target.value},
                ()=>{})
            if(e.target.name == "localidad"){
                if(e.target.value === '') {
                    localStorage.setItem('localidadBusqueda', '')
                    this.default_busqueda.localidad = '';
                    localStorage.setItem('localidadesBusqueda', [])
                    this.state.localidades = [];
                }
                else {
                    localStorage.setItem('localidadBusqueda', e.target.value)
                    this.default_busqueda.localidad = e.target.value;
                    this.state.localidades = e.target.localidades;
                }
            }
            localStorage.setItem('localidadesBusqueda', e.target.localidades)
                
            //busco las localidades si pasa medio segundo sin escribir
            let val = e.target.value + "" 
            setTimeout(()=>{
                if(val === this.state.localidad && this.state.localidad!==null && val.length >= 3)this.props.sagaGetLocalidades(val)}
                ,500)
            //si no edita en un segundo y medio abre el popup
            setTimeout(()=>{
                if(val === this.state.localidad && this.state.localidad!==null)this.setState({localidadSuggest:true})}
                ,1500)
        }
        else if(["localidad-select"].find(x=>x===e.target.name))
        {
            this.setState({"localidad":e.target.value})
            if(e.target.name == "localidad-select"){
                if(e.target.value === '') {
                    localStorage.setItem('localidadBusqueda', '')
                    this.default_busqueda.localidad = '';
                    localStorage.setItem('localidadesBusqueda', [])
                }
                else {
                    localStorage.setItem('localidadBusqueda', e.target.value)
                    this.default_busqueda.localidad = e.target.value;
                    localStorage.setItem('localidadesBusqueda', e.target.localidades)
                    this.state.localidades = e.target.localidades;
                }
            }
        }
        */
      this.setState({ [e.target.name]: e.target.value });
      if (e.target.name == "tipoUsuario") {
        if (e.target.value === 3) {
          //Tipo de usuario = 'Todos'
          //---CantFiltros
          if (this.state.filtroTipoUsuario === true) {
            this.default_busqueda.cantFiltros = this.state.cantFiltros - 1;
            this.setState({ cantFiltros: this.default_busqueda.cantFiltros });
            localStorage.setItem("cantFiltros", this.default_busqueda.cantFiltros);
            this.default_busqueda.filtroTipoUsuario = false;
          }
          //--------------
        } else {
          if (this.state.filtroTipoUsuario === false) {
            this.default_busqueda.cantFiltros = this.state.cantFiltros + 1;
            this.setState({ cantFiltros: this.default_busqueda.cantFiltros });
            localStorage.setItem("cantFiltros", this.default_busqueda.cantFiltros);
            this.default_busqueda.filtroTipoUsuario = true;
          }
        }
        localStorage.setItem("tipoUsuarioBusqueda", e.target.value);
        this.default_busqueda.tipoUsuario = e.target.value;
      }
      if (e.target.name == "nombre") {
        if (e.target.value === "") {
          //---CantFiltros
          this.default_busqueda.cantFiltros = this.state.cantFiltros - 1;
          this.setState({ cantFiltros: this.default_busqueda.cantFiltros });
          localStorage.setItem("cantFiltros", this.default_busqueda.cantFiltros);
          //--------------
          localStorage.setItem("nombreBusqueda", "");
          this.default_busqueda.nombre = "";
        } else {
          //---CantFiltros
          if (this.default_busqueda.nombre === "") {
            this.default_busqueda.cantFiltros = this.state.cantFiltros + 1;
            this.setState({ cantFiltros: this.default_busqueda.cantFiltros });
            localStorage.setItem("cantFiltros", this.default_busqueda.cantFiltros);
          }
          //--------------
          localStorage.setItem("nombreBusqueda", e.target.value);
          this.default_busqueda.nombre = e.target.value;
        }
      }
      if (e.target.name == "estado") {
        if (e.target.value === 2) {
          //---CantFiltros
          if (this.state.filtroEstado === true) {
            this.default_busqueda.cantFiltros = this.state.cantFiltros - 1;
            this.setState({ cantFiltros: this.default_busqueda.cantFiltros });
            localStorage.setItem("cantFiltros", this.default_busqueda.cantFiltros);
            this.default_busqueda.filtroEstado = false;
          }
          //--------------
          localStorage.setItem("estadoBusqueda", "");
        } else {
          if (this.state.filtroEstado === false) {
            this.default_busqueda.cantFiltros = this.state.cantFiltros + 1;
            this.setState({ cantFiltros: this.default_busqueda.cantFiltros });
            localStorage.setItem("cantFiltros", this.default_busqueda.cantFiltros);
            this.default_busqueda.filtroEstado = true;
          }
        }
        localStorage.setItem("estadoBusqueda", e.target.value);
        this.default_busqueda.estado = e.target.value;
      }
      if (e.target.name == "nombre_apellido") {
        if (e.target.value === "") {
          //---CantFiltros
          this.default_busqueda.cantFiltros = this.state.cantFiltros - 1;
          this.setState({ cantFiltros: this.default_busqueda.cantFiltros });
          localStorage.setItem("cantFiltros", this.default_busqueda.cantFiltros);
          //--------------
          localStorage.setItem("nombre_apellidoBusqueda", "");
          this.default_busqueda.nombre_apellido = "";
        } else {
          //---CantFiltros
          if (this.default_busqueda.nombre_apellido === "") {
            this.default_busqueda.cantFiltros = this.state.cantFiltros + 1;
            this.setState({ cantFiltros: this.default_busqueda.cantFiltros });
            localStorage.setItem("cantFiltros", this.default_busqueda.cantFiltros);
          }
          //--------------
          localStorage.setItem("nombre_apellidoBusqueda", e.target.value);
          this.default_busqueda.nombre_apellido = e.target.value;
        }
      }
      /*
            if(e.target.name == "razon_social"){
                if(e.target.value === '') {
                    localStorage.setItem('razon_socialBusqueda', '')
                    this.default_busqueda.razon_social = '';
                }
                else {
                    localStorage.setItem('razon_socialBusqueda', e.target.value)
                    this.default_busqueda.razon_social = e.target.value;
                }
            }
            */
    }
  };

  handleOnClickNotificaciones = (notificaciones) => {
    let value = this.state.openModalNotificaciones;
    this.setState({
      openModalNotificaciones: !value,
      notificaciones: notificaciones ? notificaciones : [],
    });
  };

  render() {
    return (
      <UsuarioListado
        usuarios={this.props.usuarios}
        instalacion={this.props.instalacion}
        mapToItem={(x) => ({
          nombre: x.tipoRol === 1 ? x.nombreUsuario : x.email,
          descripcion: x.nombre + " " + x.apellido,
          descripcion2: x.tipoRol === 1 ? x.rol : x.telefono ? x.telefono : "Sin teléfono",
          descripcion3: x.tipoRol === 1 ? x.email : x.direccion ? x.direccion : "Sin dirección",
          nivel: x.cliente ? x.cliente.nivel : "",
          habilitado: x.habilitado || x.tipoRol === 1,
          confirmado: x.confirmado,
          activo: x.activo,
          listaNegra: x.listaNegra,
          listaBlanca: x.listaBlanca,
          cantFiltros: this.state.cantFiltros,
          cantIconos: (!x.activo ? 1 : 0) + (x.listaBlanca ? 1 : 0) + (x.listaNegra ? 1 : 0),
          onClick:
            x.activo && x.habilitado
              ? () => {
                  this.props.history.push("/Usuarios/Edit/" + x.id);
                }
              : undefined,
          opciones:
            x.tipoRol === 1 /* usuario interno */
              ? [
                  x.activo
                    ? {
                        nombre: "Ver Detalles",
                        handler: () => {
                          this.props.history.push("/Usuarios/Edit/" + x.id);
                        },
                      }
                    : undefined,
                  //(x.notificaciones && x.notificaciones.length > 0)?{nombre:"Notificaciones",handler: () => {this.handleOnClickNotificaciones(x.notificaciones)}}:undefined,
                  x.activo
                    ? {
                        nombre: "Reestablecer Contraseña",
                        handler: () => {
                          this.setState({
                            openModalConfirm: true,
                            botonOk: "Reestablecer",
                            mensajeConfirmacion: `Está por reestablecer la contraseña del usuario ${x.nombreUsuario}`,
                            handleOk: () => {
                              this.props.sagaReestablecerUsuario(x.id);
                            },
                          });
                        },
                      }
                    : undefined,
                  {
                    nombre: x.activo ? "Desactivar" : "Reactivar",
                    handler: x.activo
                      ? () => {
                          this.setState({
                            openModalConfirm: true,
                            botonOk: "Desactivar",
                            mensajeConfirmacion: `Está por desactivar el usuario ${x.nombreUsuario}`,
                            handleOk: () => {
                              this.props.sagaEliminarUsuario(x.id);
                            },
                          });
                        }
                      : () => {
                          this.setState({
                            openModalConfirm: true,
                            botonOk: "Reactivar",
                            mensajeConfirmacion: `Está por reactivar el usuario ${x.nombreUsuario}`,
                            handleOk: () => {
                              this.props.sagaReactivarUsuario(x.id);
                            },
                          });
                        },
                  },
                ]
              : /* usuario externo */
                [
                  x.activo && x.habilitado
                    ? {
                        nombre: "Ver Detalles",
                        handler: () => {
                          this.props.history.push("/Usuarios/Edit/" + x.id);
                        },
                      }
                    : undefined,
                  x.notificaciones && x.notificaciones.length > 0
                    ? {
                        nombre: "Notificaciones",
                        handler: () => {
                          this.handleOnClickNotificaciones(x.notificaciones);
                        },
                      }
                    : undefined,
                  window.chrome && x.telefono
                    ? {
                        nombre: "WhatsApp",
                        handler: () => {
                          this.setState({
                            openModalConfirm: true,
                            botonOk: "Contactar",
                            mensajeConfirmacion: `Está por contactar al numero ${x.telefono} de ${x.nombre + " " + x.apellido}. Esta función solo es compatible con Google Chrome.`,
                            handleOk: () => {
                              window.open(
                                `http://wa.me/` +
                                  x.telefono
                                    .replace(/\s/g, "")
                                    .replace("-", "")
                                    .replace("+549", "54")
                              );
                            },
                          });
                        },
                      }
                    : undefined,
                  x.activo && x.confirmado
                    ? {
                        nombre: "Reestablecer Contraseña",
                        handler: () => {
                          this.setState({
                            openModalConfirm: true,
                            botonOk: "Reestablecer",
                            mensajeConfirmacion: `Está por reestablecer la contraseña del usuario ${x.nombreUsuario}`,
                            handleOk: () => {
                              this.props.sagaReestablecerUsuario(x.id);
                            },
                          });
                        },
                      }
                    : undefined,
                  x.activo && !x.habilitado
                    ? {
                        nombre: "Habilitar Cuenta",
                        handler: () => {
                          this.setState({
                            openModalConfirm: true,
                            botonOk: "Habilitar",
                            mensajeConfirmacion: `Está por habilitar el usuario ${x.nombreUsuario}`,
                            handleOk: () => {
                              this.props.sagaHabilitarUsuario(x.id);
                            },
                          });
                        },
                      }
                    : undefined,
                  x.activo && !x.confirmado
                    ? {
                        nombre: "Confirmar Correo",
                        handler: () => {
                          this.setState({
                            openModalConfirm: true,
                            botonOk: ["Enviar mail Confirmacion", "Confirmar"],
                            mensajeConfirmacion: `El correo ${x.email} no se encuentra confirmado`,
                            handleOk: [
                              () => {
                                this.props.sagaMailConfirmarUsuario(x.id);
                              },
                              () => {
                                this.props.sagaConfirmarUsuario(x.id);
                              },
                            ],
                          });
                        },
                      }
                    : undefined,
                  {
                    nombre: x.activo ? "Desactivar" : "Reactivar",
                    handler: x.activo
                      ? () => {
                          this.setState({
                            openModalConfirm: true,
                            botonOk: "Desactivar",
                            mensajeConfirmacion: `Está por desactivar el usuario ${x.nombreUsuario}`,
                            handleOk: () => {
                              this.props.sagaEliminarUsuario(x.id);
                            },
                          });
                        }
                      : () => {
                          this.setState({
                            openModalConfirm: true,
                            botonOk: "Reactivar",
                            mensajeConfirmacion: `Está por reactivar el usuario ${x.nombreUsuario}`,
                            handleOk: () => {
                              this.props.sagaReactivarUsuario(x.id);
                            },
                          });
                        },
                  },
                ],
          imagen: x.imagen
            ? x.imagen
            : x.tipoRol === 1
              ? require("../../images/default_user.png")
              : require("../../images/default_external_user.png"),
        })}
        {...this.state}
        handleOnPagination={(page) => {
          this.busqueda(page);
        }}
        handleOnChange={() => {}}
        handleOnSave={() => {}}
        handleOnSearch={(nombre) => {
          if (!this.state.openModal && nombre === "") {
            //---CantFiltros
            if (this.default_busqueda.nombre !== "") {
              this.default_busqueda.cantFiltros = this.default_busqueda.cantFiltros - 1;
              this.setState({ cantFiltros: this.default_busqueda.cantFiltros });
              localStorage.setItem("cantFiltros", this.default_busqueda.cantFiltros);
            }
            //--------------
            localStorage.setItem("nombreBusqueda", "");
            this.default_busqueda.nombre = "";
            this.setState({ ...this.default_busqueda, openModal: false }, () => {
              this.busqueda(1);
            });
          } else {
            //---CantFiltros
            if (this.default_busqueda.nombre === "" && nombre !== "") {
              this.default_busqueda.cantFiltros = this.default_busqueda.cantFiltros + 1;
              this.setState({ cantFiltros: this.default_busqueda.cantFiltros });
              localStorage.setItem("cantFiltros", this.default_busqueda.cantFiltros);
            }
            //--------------
            localStorage.setItem("nombreBusqueda", nombre);
            this.default_busqueda.nombre = nombre;
            this.setState({ ...this.default_busqueda, openModal: false }, () => {
              this.busqueda(1);
            });
          }
        }}
        handleOnAvanzado={() => {
          this.setState({ ...this.default_busqueda, openModal: true });
        }}
        handleOnCloseAvanzado={() => {
          this.setState({ openModal: false });
        }}
        handleOnClickLimpiar={() => {
          this.default_busqueda.nombre = "";
          this.default_busqueda.nombre_apellido = "";
          this.default_busqueda.tipoUsuario = 3;
          this.default_busqueda.estado = 2;
          this.default_busqueda.listaBlanca = false;
          this.default_busqueda.listaNegra = false;
          this.default_busqueda.cantFiltros = 0;
          this.default_busqueda.filtroTipoUsuario = false;
          this.default_busqueda.filtroEstado = false;
          localStorage.setItem("nombreBusqueda", "");
          localStorage.setItem("nombre_apellidoBusqueda", "");
          localStorage.setItem("tipoUsuarioBusqueda", 3);
          localStorage.setItem("estadoBusqueda", 2);
          localStorage.setItem("listaBlancaBusqueda", false);
          localStorage.setItem("listaNegraBusqueda", false);
          localStorage.setItem("cantFiltros", 0);
          localStorage.setItem("filtroTipoUsuario", false);
          localStorage.setItem("filtroEstado", false);
          this.setState({ ...this.default_busqueda });
        }}
        openModalConfirmar={this.state.openModalConfirmar}
        confirmar={() => {
          this.props.sagaConfirmarUsuario(this.state.usuario.id);
        }}
        enviarMailConfirmar={() => {
          this.props.sagaMailConfirmarUsuario(this.state.usuario.id);
        }}
        handleOnChangeFiltro={this.handleFiltro} //Toma los filtros modificados
        localidades={this.state.localidad.length >= 3 ? this.props.localidades : []}
        openModalNotificaciones={this.state.openModalNotificaciones}
        notificaciones={this.state.notificaciones}
        handleOnClickNotificaciones={this.handleOnClickNotificaciones}
      />
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      sagaGetUsuarios,
      sagaHabilitarUsuario,
      sagaConfirmarUsuario,
      sagaMailConfirmarUsuario,
      sagaEliminarUsuario,
      sagaReactivarUsuario,
      sagaReestablecerUsuario,
      sagaGetLocalidades,
      ...sessionActions,
    },
    dispatch
  );
}

function mapStateToProps(state) {
  return {
    usuarios: usuariosSelector(state),
    tiposUsuario: [
      { id: 2, name: "Externo" },
      { id: 1, name: "Interno" },
      { id: 3, name: "Todos" },
    ],
    estados: [
      { id: 1, name: "Activo" },
      { id: 0, name: "Inactivo" },
      { id: 2, name: "Todos" },
    ],
    localidades: localidadesSelector(state),
    user: usuarioSelector(state),
    instalacion: instalacionSelector(state),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(UsuariosContainer);
